import React from 'react'
import OrangeDistrictAnalysis from '../components/dashboard/OrangeDistrictAnalysis'

// OrangeDistrictAnalysis renders its own <ReportShell> internally — no outer
// wrapper needed.
const OrangeDistrictAnalysisPage = () => <OrangeDistrictAnalysis />

export default OrangeDistrictAnalysisPage
